import { AuditResourceType } from '_lib/api';
import { spatemsSelector } from '_store/spatem/selectors';
import { useLocalization } from '@fluent/react';
import { CardContent, Divider } from '@material-ui/core';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useRolePermissions } from '../../../hooks/useRolePermissions';
import AuditHistorySection from '../../items/AuditHistory';
import CardSpatemListItem from './Card';

export interface SpatemLayoutSingleProps {
  id: string;
  onUpdateSpatem?: (idExpanded: string) => void;
}

// detail card of selected SPATEM
const SpatemLayoutSingle: FC<SpatemLayoutSingleProps> = ({ id, onUpdateSpatem }) => {
  const { l10n } = useLocalization();
  const { canManageSpatem, blockedActionMode } = useRolePermissions();
  const spatems = useSelector(spatemsSelector);
  // Use useMemo to ensure we get the latest spatem when the array updates
  const spatem = useMemo(() => spatems.find((s) => s.id === id), [spatems, id]);

  if (!spatem) {
    return <>Could not find SPATEM</>;
  }

  return (
    <>
      <CardSpatemListItem
        spatem={spatem}
        asCard={false}
        text={spatem.name || spatem.identifier || spatem.id || ''}
        onUpdate={() => onUpdateSpatem?.(spatem.id)}
        writeAllowed={canManageSpatem}
        blockedActionMode={blockedActionMode}
        blockedMessage={l10n.getString('forms-rbac-readonly-action-denied')}
      />
      <CardContent style={{ paddingTop: 0 }}>
        <Divider />
        <AuditHistorySection
          key={spatem.identifier}
          resourceType={AuditResourceType.SPATEM}
          resourceId={spatem.identifier}
        />
      </CardContent>
    </>
  );
};

export default React.memo(SpatemLayoutSingle);

